"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.styles = exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styles = _interopRequireDefault(require("../../styles"));

var _tokens = require("../../styles/tokens");

var _Popper = _interopRequireDefault(require("./../../Popper"));

var _MenuList = _interopRequireDefault(require("@material-ui/core/MenuList"));

var _classnames = _interopRequireDefault(require("classnames"));

var _this = void 0;

var styles = function styles(theme) {
  return {
    paper: {
      padding: 0,
      border: _tokens.borderWidthThin + " solid " + theme.palette.grey[400]
    },
    popperPosition: {
      minWidth: '100%'
    },
    menuList: {
      padding: '0'
    }
  };
};

exports.styles = styles;

var DropdownPopper = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = props.classes,
      PopperProps = props.PopperProps,
      PaperProps = props.PaperProps,
      buttonRef = props.buttonRef,
      isMenuOpen = props.isMenuOpen,
      onClickHandler = props.onClickHandler;
  var PopperPropsModifiers = PopperProps.PopperPropsModifiers;
  var modifiers = (0, _extends2.default)({
    flip: {
      flipVariationsByContent: true
    },
    preventOverflow: {
      // this value changes the order of execution so that prevent overflow happens after flip
      // it ensures that the dropdown popper flips rather than just adjusting the offset
      order: 700
    },
    offset: {
      offset: '0, 4'
    }
  }, PopperPropsModifiers); // Extract our custom classes so they aren't passed to MUI

  var popperPosition = classes.popperPosition,
      paper = classes.paper,
      menuList = classes.menuList;

  function handleListKeyDown(event) {
    if (event.key === 'Tab' || event.key === 'Escape') {
      onClickHandler(event);
    }
  }

  var getChildren = function getChildren() {
    var items = null;

    if (props.dropdown) {
      items = _react.default.Children.toArray(props.dropdown).map(function (child, index) {
        if (! /*#__PURE__*/_react.default.isValidElement(child)) {
          console.warn('Invalid element ', child);
          return null;
        }

        return /*#__PURE__*/_react.default.cloneElement(child, {
          handleClose: handleClose.bind(_this),
          divider: index < props.dropdown.length - 1
        });
      });
    }

    return items;
  };

  var handleClose = function handleClose(event) {
    onClickHandler(event);
    buttonRef.current.focus();
  };

  return /*#__PURE__*/_react.default.createElement(_Popper.default, (0, _extends2.default)({
    anchorEl: buttonRef.current,
    open: isMenuOpen,
    onClickAway: function onClickAway(event) {
      return onClickHandler(event);
    },
    className: (0, _classnames.default)(popperPosition, 'eds-dropdown-button-popper'),
    PaperProps: (0, _extends2.default)({
      'aria-live': 'off',
      classes: {
        root: paper
      },
      elevation: 1
    }, PaperProps)
  }, PopperProps, {
    onKeyDown: handleListKeyDown,
    transition: false,
    placement: 'bottom-start',
    disablePortal: true,
    modifiers: modifiers
  }), /*#__PURE__*/_react.default.createElement(_MenuList.default, {
    className: menuList,
    role: "listbox",
    autoFocusItem: true,
    onKeyDown: handleListKeyDown
  }, getChildren()));
});

var _default = (0, _styles.default)(styles)(DropdownPopper);

exports.default = _default;